export const colors = {
    PRIMARY : "#969696" ,
    TABLE_HEADERS : "#40826D"
}